import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Resume from './components/Resume';
import CoverLetter from './components/CoverLetter';
import SkillsSummary from './components/SkillsSummary';
import ReadmePage from './components/ReadmePage';
import IndexPage from './components/IndexPage';
import ContactForm from './components/ContactForm'; // ⭐ Correct import

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<IndexPage />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="/coverletter" element={<CoverLetter />} />
          <Route path="/skillssummary" element={<SkillsSummary />} />
          <Route path="/readmepage" element={<ReadmePage />} />
          <Route path="/indexpage" element={<IndexPage />} />

          {/* ⭐ Correct route */}
          <Route path="/contact" element={<ContactForm />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
